var map = {
	"./empty.png": 11534,
	"./empty_cont.png": 8371,
	"./error.png": 46623,
	"./error_cont.png": 76592,
	"./no_lecturer.png": 89,
	"./no_permession_part_detail.png": 52412,
	"./no_permission.png": 5276,
	"./no_permission_cont.png": 86701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86473;